@let view = display();
<span class="time-delta" [attr.aria-label]="view.aria">
  @if (view.state === 'invalid') {
    <span aria-hidden="true">&mdash;</span>
  } @else if (view.state === 'now') {
    <span class="value">now</span>
  } @else {
    @if (view.direction === 'future') {
      <span i18n="@@timedelta.in">in</span>
    }
    <span class="value" aria-hidden="true">{{ view.text }}</span>
    @if (view.direction === 'past') {
      <span i18n="@@timedelta.ago">ago</span>
    }
  }
</span>
